module.exports = __webpack_public_path__ + "img/estrada_velha1.0ca6921c.jpg";